import React, { useState } from 'react';
import '../dashboard/Createcampaign.css';
import { Icon } from '@mui/material';

import img from "./img/img1.png";



interface AdType {
  id: number;
  description: string;
  minimumBid: string;
  bidModel: string;
  impressions: string;
  creative: string;
  traffic: string;
  targetContext: string;
  desktopAdUrl: string;
  mobileAdUrl: string;
  label: string;
  bgimg: string;
}

const steps = [
  { label: 'Ad Type', active: true },
  { label: 'GEO', active: false },
  { label: 'Targeting', active: false },
  { label: 'Quality', active: false },
  { label: 'Bid', active: false },
  { label: 'Creative', active: false },
  { label: 'Budget', active: false },
  { label: 'Advanced Settings', active: false, hasInfo: true },
];

const adTypes: AdType[] = [
  {
    id: 1,
    description:
      "Direct navigation traffic from expired links, typos or domains. Users are captured and immediately redirected to your landing page, in the active window, while browsing. High-intent users and exceptional conversion rates!",
    minimumBid: "$5 Minimum",
    bidModel: "CPV - Cost Per Visitor",
    impressions: "15,501,429,532",
    creative: "Landing Page URL",
    traffic: "Mainstream / Adult",
    targetContext: "<li> Run of Network <li> Keywords <li> Brand Names",
    desktopAdUrl:
      "https://my.bidvertiser.com/bdv/BidVertiser/BidVertiserA/bdv_adv_Ads_IPTargeting.dbm?ID_Token=P650P103N443799&AID=710749&Ad_Type=99",
    mobileAdUrl: "lnk",
    label: ' Direct', // added 'Ad Type' label here
    bgimg: img
  },
  {
    id: 2,
    description:
      "Pops are the new browser windows or tabs showing over or under a currently viewed page. They appear automatically during the browsing session and display your landing page. Drive unmatched awareness with high volume quality traffic!",
    minimumBid: "$5 Minimum",
    bidModel: "CPV - Cost Per Visitor",
    impressions: "99,604,344,655",
    creative: "Landing Page URL",
    traffic: "Mainstream / Adult",
    targetContext: "<li> Run of Network",
    desktopAdUrl:
      "https://my.bidvertiser.com/bdv/BidVertiser/BidVertiserA/bdv_adv_Ads_IPTargeting.dbm?ID_Token=P650P103N443799&AID=710749&Ad_Type=19&RON=-1&LISTOFCATS=1;2449",
    mobileAdUrl:
      "https://my.bidvertiser.com/bdv/BidVertiser/BidVertiserA/bdv_adv_Ads_IPTargeting.dbm?ID_Token=P650P103N443799&AID=710749&Ad_Type=19&RON=-1&LISTOFCATS=1;2449&UASET=Mobile",
    label: 'Pop-Under', // added 'GEO' label here
    bgimg: require('./img/img2.png')

  },
  {
    id: 3,
    description:
      "In-Page Push ads match the look & feel of the website in which they appear and are displayed as an \"alert\" message which strongly captures the attention. Think of a new WhatsApp message alert that you receive - as effective as that!",
    minimumBid: "$5 Minimum",
    bidModel: "CPC - Cost Per Click",
    impressions: "12,148,317,027",
    creative: "Text & Image [recommended image size: 300 x 200] + Landing Page URL",
    traffic: "Mainstream / Adult",
    targetContext: "<li> Run of Network",
    desktopAdUrl:
      "https://my.bidvertiser.com/bdv/BidVertiser/BidVertiserA/bdv_adv_Ads_IPTargeting.dbm?ID_Token=P650P103N443799&AID=710749&Ad_Type=1&RON=-1&LISTOFCATS=1;2449",
    mobileAdUrl:
      "https://my.bidvertiser.com/bdv/BidVertiser/BidVertiserA/bdv_adv_Ads_IPTargeting.dbm?ID_Token=P650P103N443799&AID=710749&Ad_Type=1&RON=-1&LISTOFCATS=1;2449",
    label: 'In-Page Push', // added 'Targeting' label here
    bgimg: require('./img/img3.png')

  },
  {
    id: 4,
    description:
      "Push Ads appear as alert-style messages on both desktop and mobile, designed to capture user attention with minimal interruption. Perfect for engaging users with concise, actionable messaging.",
    minimumBid: "$5 Minimum",
    bidModel: "CPC - Cost Per Click",
    impressions: "Dynamic",
    creative: "Text & Image + Landing Page URL",
    traffic: "Mainstream / Adult",
    targetContext: "<li> Run of Network",
    desktopAdUrl: "https://example.com/desktop-push-ads-url",
    mobileAdUrl: "https://example.com/mobile-push-ads-url",
    label: 'Native', // added 'Quality' label here
    bgimg: require('./img/img4.png')

  },
  {
    id: 5,
    description:
      "Contextual Pops deliver high-impact ads through injection traffic, showing your message in relevant browsing sessions. These are ideal for achieving visibility without disrupting user experience.",
    minimumBid: "$5 Minimum",
    bidModel: "CPV - Cost Per Visitor",
    impressions: "Dynamic",
    creative: "Landing Page URL",
    traffic: "Mainstream / Adult",
    targetContext: "<li> Contextual Targeting <li> Injection Traffic",
    desktopAdUrl: "https://example.com/desktop-contextual-pops-url",
    mobileAdUrl: "https://example.com/mobile-contextual-pops-url",
    label: 'Video', // added 'Bid' label here
    bgimg: require('./img/img5.png')

  },
  {
    id: 6,
    description:
      "Native ads match the look & feel of the website in which they appear and unlike banner ads, they look less like ads and more like part of the editorial flow of the page. Expose your content to a natural flow of engaged visitors!",
    minimumBid: "$5 Minimum",
    bidModel: "CPC - Cost Per Click",
    impressions: "4,089,007,719",
    creative: "Text & Image [recommended image size: 300 x 200] + Landing Page URL",
    traffic: "Mainstream / Adult",
    targetContext: "<li> Run of Network",
    desktopAdUrl:
      "https://my.bidvertiser.com/bdv/BidVertiser/BidVertiserA/bdv_adv_Ads_IPTargeting.dbm?ID_Token=P650P103N443799&AID=710749&Ad_Type=14&RON=-1&LISTOFCATS=1;2449",
    mobileAdUrl:
      "https://my.bidvertiser.com/bdv/BidVertiser/BidVertiserA/bdv_adv_Ads_IPTargeting.dbm?ID_Token=P650P103N443799&AID=710749&Ad_Type=14&RON=-1&LISTOFCATS=1;2449&UASET=Mobile",
    label: 'Push', // added 'Quality' label here
    bgimg: require('./img/img6.png')

  },
  {
    id: 7,
    description:
      "Video ads are launched before the start of the main video on the site (pre-roll).Video Ads. Recommended dimensions 1920 x 1080, MOV/MP4, Max size 20MB + Landing Page URL",
    minimumBid: "$5 Minimum",
    bidModel: "CPM",
    impressions: "Dynamic",
    creative: "Video Ads. Recommended dimensions 1920 x 1080, MOV/MP4, Max size 20MB + Landing Page URL.",
    traffic: "Mainstream / Adult",
    targetContext: "<li> Run of Network",
    desktopAdUrl:
      "https://my.bidvertiser.com/bdv/BidVertiser/BidVertiserA/bdv_adv_Ads_IPTargeting.dbm?ID_Token=P650P103N443799&AID=710749&Ad_Type=15&RON=-1&LISTOFCATS=1;2449",
    mobileAdUrl:
      "https://my.bidvertiser.com/bdv/BidVertiser/BidVertiserA/bdv_adv_Ads_IPTargeting.dbm?ID_Token=P650P103N443799&AID=710749&Ad_Type=15&RON=-1&LISTOFCATS=1;2449&UASET=Mobile",
    label: 'Contextual Pops', // added 'Bid' label here
    bgimg: require('./img/img7.png')

  },
];



interface StepProps {
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  formData: {
    adFormat: string;
    [key: string]: string;
  };
}

const AdTypeStep: React.FC<StepProps> = ({ handleInputChange, formData }) => {



  const setOptions = (id: number) => {
    console.log(`Option ${id} selected`);
  };


  const [selectedAd, setSelectedAd] = useState<AdType | null>(null);

  const handleAdSelect = (id: number) => {
    const adType = adTypes.find((ad) => ad.id === id);
    if (adType) {
      setSelectedAd(adType);

      // Update the formData with the selected ad label
      const eventMock = {
        target: { name: 'adFormat', value: `${adType.label} Ad` },
      } as React.ChangeEvent<HTMLInputElement>;
      handleInputChange(eventMock);
    }
  };



  return (
    <>

      <div >


        <div className="cardsection" style={{ backgroundImage: 'url()', backgroundSize: 'cover', padding: '20px' }}>
          <p style={{ marginLeft: '20px' }}>
            Each ad type will direct a different flow of visitors to your promoted
            page. We strongly recommend testing all ad types:
          </p>
          <div className="button-group" style={{ marginLeft: '-25px' }}>
            {adTypes.map((ad) => (
              <div
                key={ad.id}
                className={`button ${selectedAd?.id === ad.id ? 'active' : ''}`}
                onClick={() => handleAdSelect(ad.id)}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  backgroundColor: selectedAd?.id === ad.id ? '#003264' : 'white', // active button styling
                  padding: '10px',
                  borderRadius: '8px',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  cursor: 'pointer',
                  userSelect: 'none',
                  backgroundImage: `url(${ad.bgimg})`, // Ensure it's in `url()`
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                <Icon style={{ fontSize: '24px', marginBottom: '8px' }} />
                <span className="span-label">{ad.label} Ad</span>
              </div>
            ))}
          </div>


          {selectedAd && (
            <div id="ad_info" style={{ display: 'block', marginTop: '20px', fontSize: '12px', width: '100%', backgroundColor: 'transparent' }}>
              <div style={{ display: 'flex', gap: '30px', fontSize: '12px', border: 'solid', borderWidth: '0px 0px 1px 0px' }}>
                <p id="desk" style={{ fontSize: '14px', color: '#1173B7', fontWeight: '400', width: '240px' }}>Ad's Description  </p>
                <p id="desk" style={{ fontSize: '12px' }}>{selectedAd.description}</p>
              </div>

              <div style={{ display: 'flex', gap: '30px', fontSize: '12px', width: '100%', border: 'solid', borderWidth: '0px 0px 1px 0px' }}>
                <p id="MDB" style={{ fontSize: '14px', color: '#1173B7', fontWeight: '400', width: '190px' }}>Daily Budget  </p>
                <p id="MDB" style={{ fontSize: '12px' }}>{selectedAd.minimumBid}</p>
              </div>


              <div style={{ display: 'flex', gap: '30px', fontSize: '12px', width: '100%', border: 'solid', borderWidth: '0px 0px 1px 0px' }}>
                <p id="model" style={{ fontSize: '14px', color: '#1173B7', fontWeight: '400', width: '190px' }}>Model  </p>
                <p id="model" style={{ fontSize: '12px' }}>{selectedAd.bidModel}</p>
              </div>


              <div style={{ display: 'flex', gap: '30px', fontSize: '12px', width: '100%', border: 'solid', borderWidth: '0px 0px 1px 0px' }}>
                <p id="imps" style={{ fontSize: '14px', color: '#1173B7', fontWeight: '400', width: '190px' }}>Daily Impression   </p>
                <p id="imps" style={{ fontSize: '12px' }}>{selectedAd.impressions}</p>
              </div>


              <div style={{ display: 'flex', gap: '30px', fontSize: '12px', width: '100%', border: 'solid', borderWidth: '0px 0px 1px 0px' }}>
                <p id="creative" style={{ fontSize: '14px', color: '#1173B7', fontWeight: '400', width: '190px' }}>Creaive  </p>
                <p id="creative" style={{ fontSize: '12px' }}>{selectedAd.creative}</p>
              </div>

              <div style={{ display: 'flex', gap: '30px', fontSize: '12px', width: '100%', border: 'solid', borderWidth: '0px 0px 1px 0px' }}>
                <p id="traffic" style={{ fontSize: '14px', color: '#1173B7', fontWeight: '400', width: '190px' }}>Traffic Type  </p>
                <p id="traffic" style={{ fontSize: '12px' }}>{selectedAd.traffic}</p>
              </div>


              <div style={{ display: 'flex', gap: '30px', fontSize: '12px', width: '100%', border: 'solid', borderWidth: '0px 0px 1px 0px' }}>
                <p id="traffic" style={{ fontSize: '14px', color: '#1173B7', fontWeight: '400', width: '190px' }}>Ad Platform </p>
                <p id="traffic" style={{ fontSize: '12px' }}>Desktop / Mobile</p>
              </div>



              <div>
                <td>
                  <table className="TABLE_STYLE" cellPadding={0} cellSpacing={0} >
                    <tbody>
                      <tr >
                        <td width="150" valign="top">
                          <span style={{ color: "#1173b7" }}>Targeting :</span>
                          <div style={{ paddingLeft: "20px" }}>
                          </div>
                        </td>
                        <td width="150" valign="top">
                          <span style={{ color: "#1173b7" }}>Geographic:</span>
                          <div style={{ paddingLeft: "20px" }}>
                            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                              <li>Country</li>
                              <li>Region</li>
                              <li>State</li>
                              <li>City</li>
                              <li>Go Local - by Zip</li>
                            </ul>
                          </div>
                        </td>
                        <td
                          width="150"
                          valign="top"
                          style={{ borderLeft: "1px solid #1173b7", paddingLeft: "10px" }}
                        >
                          <span style={{ color: "#1173b7" }}>Context:</span>
                          <div style={{ paddingLeft: "20px" }} id="targetContext">
                            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                              <li>Run of Network</li>
                              <li>Keywords</li>
                              <li>Brand Names</li>
                            </ul>
                          </div>
                        </td>
                        <td
                          width="150"
                          valign="top"
                          style={{ borderLeft: "1px solid #1173b7", paddingLeft: "10px" }}
                        >
                          <span style={{ color: "#1173b7" }}>Filters:</span>
                          <div style={{ paddingLeft: "20px" }}>
                            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                              <li>Quality</li>
                              <li>Day Parting</li>
                              <li>Freq Cap</li>
                              <li>SubID</li>
                            </ul>
                          </div>
                        </td>
                        <td
                          width="150"
                          valign="top"
                          style={{ borderLeft: "1px solid #1173b7", paddingLeft: "10px" }}
                        >
                          <span style={{ color: "#1173b7" }}>Device:</span>
                          <div style={{ paddingLeft: "20px" }}>
                            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                              <li>Operating System</li>
                              <li>Browser</li>
                            </ul>
                          </div>
                        </td>
                        <td
                          width="150"
                          valign="top"
                          style={{ borderLeft: "1px solid #1173b7", paddingLeft: "10px" }}
                        >
                          <span style={{ color: "#1173b7" }}>Environmental:</span>
                          <div style={{ paddingLeft: "20px" }}>
                            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                              <li>Connection Type</li>
                              <li>ISP</li>
                              <li>Carrier</li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>

                <div>

                </div>
              </div>
             
            </div>
          )}
        </div>


      </div>


    </>
  );
};

export default AdTypeStep;
